import React from "react";
import Button from "helpers/button";
import VideoPlayer from "components/video-player";

const VideoSection = ({ data }) => {
  return (
    <div className="">
      <div className="container">
        <div className="text-center mx-auto">
          <h2 className="header mb-6 !text-gray-800">{data.title}</h2>
          <p className="font-sans text-sm font-medium text-gray-600 sm:max-w-[240px] mx-auto">
            {data.description}
          </p>
        </div>

        <div className="my-9 sm:my-6 h-[600px] sm:h-72">
          <VideoPlayer videoLink={data.video.video} />
        </div>

        {data.button && (
          <div className="flex items-center justify-center">
            <Button button={data.button} />
          </div>
        )}
      </div>
    </div>
  );
};

export default VideoSection;
